module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, commenter, i, len, ref;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (!this.commentCollection.isEmpty()) {
        $o.push("<div class='filters-wrapper'>\n  <select class='filters js-resolved-filter' name='resolved-filter' data-behavior='select2' data-select2options='{\"theme\": \"filters\", \"dropdownAutoWidth\": \"true\"}'>\n    <option value='' selected='" + ($e($c(this.collectionFilters['resolved'] === ""))) + "'>All comments</option>\n    <option value='" + ($e($c(1))) + "' selected='" + ($e($c(this.collectionFilters['resolved'] === 1))) + "'>Resolved comments</option>\n    <option value='" + ($e($c(0))) + "' selected='" + ($e($c(this.collectionFilters['resolved'] === 0))) + "'>Open comments</option>\n  </select>\n  <select class='filters js-commenter-filter' id='commenter-filter' name='commenter-filter' data-behavior='select2' data-select2options='{\"theme\": \"filters\", \"dropdownAutoWidth\": \"true\"}'>\n    <option value='mentioned' selected='" + ($e($c(this.collectionFilters['mentioned'] === true))) + "'>Comments mentioning you</option>\n    <optgroup label='Comments made by'>\n      <option value='' selected='" + ($e($c(!this.collectionFilters['authorable_id'] && !this.collectionFilters['mentioned']))) + "'>All commenters</option>");
        ref = this.commenters;
        for (i = 0, len = ref.length; i < len; i++) {
          commenter = ref[i];
          $o.push("      <option value='" + ($e($c(commenter.value))) + "' selected='" + ($e($c(this.collectionFilters['authorable_id'] === commenter.value))) + "' notranslate>" + ($e($c(commenter.name))) + "</option>");
        }
        $o.push("    </optgroup>\n  </select>\n</div>");
      }
      $o.push("<div class='js-comments'>");
      if (this.comments.length === 0) {
        if (this.commentCollection.isEmpty()) {
          $o.push("  <h3 class='empty js-no-comments'>\n    This story doesn't have any comments (yet).\n  </h3>");
        } else {
          $o.push("  <h3 class='empty js-no-comments-filters'>\n    There are no comments matching your filters.\n  </h3>");
        }
      }
      $o.push("</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/comment_list.js.hamlc
// module id = 1414
// module chunks = 17